export default "__VITE_ASSET__DvimaUDY__"